import React from "react";
// @material-ui/icons
import { CircularProgress } from '@mui/material';
import DataTable from "components/Table/DataTable";
// core components
import { useState } from 'react';
import { useQuery } from "react-query";
// import BackupIcon from "@material-ui/icons/Backup";
import BackupIcon from '@mui/icons-material/SettingsBackupRestore';
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import { Alert } from '@mui/material';
import FailureIcon from '@mui/icons-material/Cancel';
import SuccessIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import { green, red } from '@mui/material/colors';
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";
import PrettyBytes from 'react-pretty-bytes';

export default function BackupTable(props) {
  const url = "/api/v1/backup/backups";
  const [token, setToken] = useToken();
  useAxiosAuth(token);
  const BackupName = () => (
      <BackupIcon fontSize="medium" />
  );
  const columns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Last Modified", accessor: "last_modified", align: "left" },
    { Header: "Size", accessor: "size",align: "center" },
    { Header: "Status", accessor: "status", align: "center" }
  ];
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const { isLoading, error, data } = useQuery(
    "backup-backups", () => axios.get(
      url + "/" +  props.backupId + "/pg",
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
    ),
    {
      refetchInterval: 10000
    }
  )

  const backupData = (data) => {
    let tableData = {
      columns: columns,
      rows: []
    };

    if (data && data.hasOwnProperty("items") && data.items.length > 0) {
      tableData.rows = data.items.map((item) => {
      let status = (
        <Tooltip title="Job Pending" placement="top">
          <PendingIcon fontSize="medium" style={{ position: "relative" }} />
        </Tooltip>
      );

      if ("failed" == item.status) {
        status = (
          <Tooltip title="Job Failed" placement="top">
            <FailureIcon
              fontSize="medium"
              style={{ color: red[500], position: "relative" }}
            />
          </Tooltip>
        );
      } else if ("active" == item.status) {
        status = (
          <Tooltip title="Job Running" placement="top">
            <CircularProgress
              size={20}
              style={{ color: green[500], position: "relative" }}
            />
          </Tooltip>
        );
      } else if ("succeeded" == item.status) {
        status = (
          <Tooltip title="Job Completed" placement="top">
            <SuccessIcon
              fontSize="medium"
              style={{ color: green[500], position: "relative" }}
            />
          </Tooltip>
        );
      }
          return {
            icon: <BackupName />,
            name: (item.file_info.name) ? item.file_info.name : "",
            last_modified: (item.file_info.last_modified) ? item.file_info.last_modified
              : "",
            size: (item.file_info.size) ? <PrettyBytes bytes={item.file_info.size}  /> : "",
            status: status,
          }
        }
      )
      
    }

    return tableData;
  }


  return (
    <React.Fragment>
        {isError ?
          <Box sx={{ paddingLeft: "10px" }}>
            <Alert severity="error">
              {message ? message : "error"}
            </Alert>
          </Box>
          : null
        }
        {error ?
          <Box>
            <Alert severity="error">
              Error loading backup data
            </Alert>
          </Box>
          : null
        }

      {isLoading && <CircularProgress size={24} style={{marginLeft: '45%', position: 'relative', top: 4}}/>}

      <DataTable
        tableTitle="DB Backups"
        table={ backupData(data) }
        canSearch={true}
        showTotalEntries={true}
        isSorted={true}
        initialSortField="last_modified"
        initialSortDesc={true}
        noEndBorder
        entriesPerPage={true}
      />
    </React.Fragment>
  );
}
